import { styled } from '@mui/material/styles';
import { Divider, Typography, TableCell, TableContainer, TableCellProps } from '@mui/material';
import DocumentHistoryTable from './DocumentHistoryTable';
import TargetTrainingSet from './TargetTrainingSet';
import VendorName from './VendorName';
import { IDocumentUnscoped } from '../../../types/my-types';
import AssignedTrainingSetList from './AssignedTrainingSetList';
import ExtractionList from './ExtractionList';
import PackageList from './PackageList';
import DocumentDataStatusSection from './DocumentDataStatusSection';
import DocumentRelationshipsSection from './DocumentRelationshipsSection';

// Shared styled components for the associated components
export const TypographySmallTitle = styled(Typography)({
  fontSize: '10px',
  fontWeight: 'bold',
});

export const SectionContainer = styled('div')({
  marginTop: '20px',
});

export const ValueTypography = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '16px',
});

export const NotAssignedTypography = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '12px',
});

export const TableContainerStyled = styled(TableContainer)({
  border: '1px solid #E0E0E0',
  borderRadius: '6px',
  marginTop: '10px',
});

export const TableCellStyled = styled(TableCell)<TableCellProps>({
  padding: '8px',
  fontSize: '12px',
});

interface IDocumentDetailsLeftProps {
  documentData: IDocumentUnscoped;
}

const DocumentDetailsLeft = ({ documentData }: IDocumentDetailsLeftProps) => {
  const hasDocumentRelationships =
    !!documentData.relationships?.split?.parent ||
    (documentData.relationships?.split?.children?.length ?? 0) > 0;

  return (
    <div
      style={{
        height: `calc(100vh - 64px)`,
        overflow: 'scroll',
      }}
    >
      <div style={{ padding: '5px 20px 15px' }}>
        <VendorName documentData={documentData} />

        <Divider sx={{ my: 2 }} />
        <DocumentDataStatusSection documentData={documentData} />

        {hasDocumentRelationships && (
          <>
            <Divider sx={{ my: 2 }} />
            <DocumentRelationshipsSection documentData={documentData} />
          </>
        )}

        <Divider sx={{ my: 2 }} />

        <TargetTrainingSet documentData={documentData} />

        <Divider sx={{ my: 2 }} />

        <PackageList documentData={documentData} />
        <AssignedTrainingSetList documentData={documentData} />
        <ExtractionList documentData={documentData} />

        {/* <DocumentHistoryTable /> */}
      </div>
    </div>
  );
};

export default DocumentDetailsLeft;
